import { API, Storage } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

import SpareDocumentForm from "components/spares/documents/SpareDocumentForm";
import { createSpareDocument } from "graphql/mutations";
import LoaderFullScreen from "components/utils/LoaderFullScreen";

const SpareDocumentCreateForm = ({ spareID, onSuccess }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const spareDocument = {
    fileName: "",
    fileSrc: "",
  };

  async function onSubmit(valuesParam) {
    try {
      setLoading(true);

      const { fileName, fileSrc: fileObj } = valuesParam;
      let fileSrc = "";

      if (fileObj) {
        fileSrc = `${fileObj.name
          .split(".")
          .slice(0, -1)
          .join(".")}_${Date.now()}.${fileObj.name.split(".").slice(-1)[0]}`;

        await Storage.put(`spares/${fileSrc}`, fileObj, {
          contentType: fileObj.type,
          level: "public",
        });
      }

      await API.graphql({
        query: createSpareDocument.replaceAll("__typename", ""),
        variables: {
          input: {
            spareID,
            fileName,
            fileSrc,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/spares");
    } catch (err) {
      console.log("Error Spare Document creation", err);
      toast.error(strings.responses.unexpectedError);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <SpareDocumentForm
        onSubmit={onSubmit}
        initialValues={spareDocument}
      />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Documento de Repuesto",
    successAdded: "Documento de Repuesto agregado con éxito",
    responses: {
      unexpectedError: "Error inesperado en la creación",
    },
  },
});

export default SpareDocumentCreateForm;
